var filterParams = function (params) {
    return Object.fromEntries(Object.entries(params).filter(function (_a) {
        var _ = _a[0], value = _a[1];
        return value !== undefined && value !== null;
    }));
};
export { filterParams };
